<template>
  <app-layout>
    <customer-tracking-table :consultant-id="consultantId"></customer-tracking-table>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import CustomerTrackingTable from '@/modules/admin/customer-tracking/components/CustomerTrackingTable.vue';
export default {
  name: 'CustomerTracking',
  components: { AppLayout, CustomerTrackingTable },
  beforeMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.hasOwnProperty('consultant_profile') && user.consultant_profile !== null) {
      this.consultant_id = user.consultant_profile['id'];
    }
  },
  data() {
    return {
      consultant_id: null,
    };
  },
  computed: {
    consultantId() {
      return this.consultant_id;
    },
  },
};
</script>

<style scoped></style>
